import { createSlice } from "@reduxjs/toolkit";
import { getDocTypeApi } from "../documentUploadApi";

const getDocTypeApiSlice = createSlice({
  name: "getDocType",
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handle fetchCommunityData cases
      .addCase(getDocTypeApi.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getDocTypeApi.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getDocTypeApi.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});
export default getDocTypeApiSlice.reducer;
